export enum CaptchadropdownOptions {
    TEXT_BASED = "TEXTBASED",
    IMAGE_BASED = "IMAGEBASED"
}

export enum TimedropdownOptions {
    MIN = "MIN",
    SECONDS = "SECONDS"
}

export interface ICaptchaFieldConfigurationServer {
    captchadropdownOptions?: string
    captchaResetTime?: string
    errorMessage?: string
    captchabgColor?: string
}
export interface ICaptchaFieldConfigurationClient {
    captchadropdownOptions?: string
    captchaResetTime?: string
    errorMessage?: string
    captchabgColor?: string
}